import * as actionTypes from 'actions/admin/actors';

const initialState = {
    searchResult: {
        isLoading: false
    },
    searchParameters: {}
};

const actors = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMIN_ACTORS_SEARCH_SUCCESS:
            return { ...state, searchResult: action.payload };
        case actionTypes.ADMIN_ACTORS_SET_SEARCH_PARAMETERS:
            return { ...state, searchParameters: action.searchParameters };
        default:
            return state;
    }
};


export default actors;
